import { Pencil, Trash2, Flame, Star } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { euro } from "@/lib/api";

export const ProductRow = ({ p, onEdit, onDelete, onToggle }) => (
  <li data-testid={`admin-product-${p.id}`} className="grid grid-cols-[auto_1fr_auto] sm:grid-cols-[auto_1fr_auto_auto_auto] items-center gap-3 sm:gap-5 p-3 sm:p-4 rounded-2xl border border-white/10 bg-[#16161A]">
    <div className="relative w-14 h-14 rounded-xl overflow-hidden bg-[#0D0D0F]">
      {p.image ? <img src={p.image} alt="" className="w-full h-full object-cover" /> : <Flame className="absolute inset-0 m-auto w-6 h-6 text-[#FF5500]" />}
    </div>
    <div className="min-w-0">
      <p className="font-semibold truncate flex items-center gap-1.5">{p.featured && <Star className="w-3.5 h-3.5 shrink-0 fill-[#FFC72C] text-[#FFC72C]" />}{p.name}</p>
      <p className="text-xs text-zinc-400 truncate">{p.category}</p>
    </div>
    <span className="font-display text-lg text-[#FF5500] tabular-nums">{euro(p.price)}</span>
    <label className="col-span-2 sm:col-span-1 flex items-center gap-2 text-xs text-zinc-300">
      <Switch checked={!!p.available} onCheckedChange={(v) => onToggle(p, v)} data-testid={`admin-toggle-${p.id}`} />
      {p.available ? "Disponibile" : "Esaurito"}
    </label>
    <div className="flex justify-end gap-1">
      <button type="button" onClick={() => onEdit(p)} data-testid={`admin-edit-${p.id}`} aria-label="Modifica" className="grid place-items-center w-10 h-10 rounded-full hover:bg-white/10 transition-colors"><Pencil className="w-4 h-4" /></button>
      <button type="button" onClick={() => onDelete(p)} data-testid={`admin-delete-${p.id}`} aria-label="Elimina" className="grid place-items-center w-10 h-10 rounded-full text-red-400 hover:bg-red-500/10 transition-colors"><Trash2 className="w-4 h-4" /></button>
    </div>
  </li>
);
